import React, { useState } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { CompetitionEventNameState } from 'src/domains/sportsbook/trading/view/eventDetails/eventSettings/EventSettingsElements/CompetitionEventNameState';

import { useAsObservableSource } from 'mobx-react-lite';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';


interface CompetitionEventNamePropsTypes {
    eventId: EventId
}

export const CompetitionEventName = observer('CompetitionEventName', (propsIn: CompetitionEventNamePropsTypes) => {
    const props = useAsObservableSource(propsIn);

    const { sdkStaff } = useAppStateContext();
    const [competitionEventNameState] = useState(() => new CompetitionEventNameState(() => props.eventId, sdkStaff));
    
    const {
        eventName, competitionName,
        eventNameValue, setEeventNameValue,
        isEditMode, setIsEditMode,
        onSaveEventName
    } = competitionEventNameState;

    if (isEditMode === true) {
        return (
            <section className='event-details-box'>
                <h4>Competition - event name</h4>
                <div className='event-details-name'>
                    {
                        <div className='element'>
                            <input
                                type='text'
                                value={eventNameValue}
                                onChange={setEeventNameValue}
                            />
                        </div>
                    }
                    {competitionName}
                    <br />
                    <a href='#' className='btn' onClick={onSaveEventName}>Save</a>
                </div>
            </section>
        );
    }
    return (
        <section className='event-details-box'>
            <h4>Competition - event name</h4>
            <div className='event-details-name'>
                <strong>{competitionName} - {eventName}</strong>
                <a href='#' className='event-details-name-edit' onClick={setIsEditMode}>Edit</a>
            </div>
        </section>
    );
});
